module.exports = __webpack_public_path__ + "static/media/README.e7c57a83.md";